
import { computed, ref, toRaw } from '@vue/reactivity'
import { onMounted } from 'vue'
import { UploadOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { uploadFileToOss } from '@/utils/oss'
import { message } from 'ant-design-vue'
import config from '@/config'
export default {
  emits: ['onChange'],
  components: {
    UploadOutlined,
    DeleteOutlined,
    EditOutlined
  },
  props: {
    form: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup (props, { emit }) {
    const formData = computed(() => props.form)
    const store = useStore()
    const isHover = ref(false)
    const handleMouseEnter = () => {
      isHover.value = true
    }
    const hasSheet = computed(() => formData.value.evxml_file_url === undefined || formData.value.evxml_file_url === '')

    const deleteVisible = ref(false)

    const handleMouseLeave = () => {
      isHover.value = false
    }

    const showDeleteModal = () => {
      deleteVisible.value = true
    }

    const handleDeleteCancel = () => {
      deleteVisible.value = false
    }

    const handleDeleteSheet = () => {
      const formInfo = {
        ...toRaw(formData.value),
        evxml_file_url: '',
        evxml_file_size: undefined,
        evxml_file_md5: ''
      }
      console.log(formInfo)
      emit('onChange', formInfo)
      handleDeleteCancel()
    }

    const uploadDataForm = (url, md5, size) => {
      console.log(url, md5, size)
      const formInfo = {
        ...toRaw(formData.value),
        evxml_file_url: url,
        evxml_file_size: size,
        evxml_file_md5: md5
      }
      console.log(formInfo)
      emit('onChange', formInfo)
    }

    const handleBeforeUpload = file => {
      console.log('上传曲谱', file)
      try {
        uploadFileToOss(file, true, undefined, '', false).then(data => {
          const { url, md5, size } = data
          uploadDataForm(url, md5, size)
          message.success('上传曲谱成功')
        })
      } catch (error) {
        console.log(error)
      }
      return false
    }

    const jumpToEdit = () => {
      const url = window.location.href
      const index = url.search('/resource/sheet-songs/')
      const id = url.slice(index, url.length).split('/')[3]
      const token = localStorage.getItem('resource_token')
      const { acc_file_url, ori_file_url } = formData.value
      const resourceCenter = config.mainApps.institutionPlatform.baseURL
      const resourceCenterApiPrefix = config.mainApps.institutionPlatform.apiPrefix
      const shenyue = config.mainApps.shenyue.baseURL
      const shenyueApiPrefix = config.mainApps.shenyue.apiPrefix
      window.open(`${config.musicScore}/skip.html?id=${id}&token=${token}` +
      `&resourceCenter=${resourceCenter}&resourceCenterApiPrefix=${resourceCenterApiPrefix}` +
      `&shenyue=${shenyue}&shenyueApiPrefix=${shenyueApiPrefix}`)
    }

    const handleShowEditSheetButton = () => {
      return window.location.href.search('/resource/sheet-songs/create/') === -1
    }

    return {
      formData,
      store,
      isHover,
      hasSheet,
      deleteVisible,
      handleMouseEnter,
      handleMouseLeave,
      handleBeforeUpload,
      handleDeleteSheet,
      showDeleteModal,
      handleDeleteCancel,
      jumpToEdit,
      handleShowEditSheetButton
    }
  }
}
